/*
 * ReAmour 専用ループスライダー（Splide ラッパー）
 * - 標準の slideshow コンポーネントには一切干渉しない独立実装
 * - type: 'loop' + focus: 'center' + padding で「両端も折り返しチラ見え」を実現
 * - Splide が realIndex を管理するため、ページネーション（ドット）は表示と常に一致する
 * - autoplay + drag は Splide が整合管理するため、SPでスワイプ後も自動再生が復帰する
 * 設定値はセクション側の data-* 属性から受け取る。
 */
(function () {
  'use strict';

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function buildOptions(el) {
    var d = el.dataset;
    var opts = {
      type: 'loop',
      focus: 'center',
      perPage: 1,
      gap: d.gap || '12px',
      padding: { left: (d.peekPc || '14') + '%', right: (d.peekPc || '14') + '%' },
      arrows: d.arrows === 'true',
      pagination: d.pagination === 'true',
      drag: true,
      speed: parseInt(d.speed || '600', 10),
      keyboard: 'focused',
      // Splideのデフォルトaria-labelは英語のため日本語で上書き
      i18n: { prev: '前のスライド', next: '次のスライド' },
      breakpoints: {
        749: {
          padding: { left: (d.peekSp || '8') + '%', right: (d.peekSp || '8') + '%' },
          gap: d.gap || '8px'
        }
      }
    };

    // 自動再生は prefers-reduced-motion を尊重（有効時は無効化／WCAG 2.2.2）
    if (d.autoplay === 'true' && !prefersReducedMotion()) {
      opts.autoplay = true;
      opts.interval = parseInt(d.interval || '3000', 10);
      opts.pauseOnHover = d.pauseOnHover === 'true';
      opts.pauseOnFocus = false;
      opts.resetProgress = false;
    }

    return opts;
  }

  function mount(el) {
    if (!el || el.classList.contains('is-initialized')) return;
    if (typeof Splide === 'undefined') return false;
    try {
      el._splideInstance = new Splide(el, buildOptions(el)).mount();
    } catch (e) {
      if (window.console && console.warn) console.warn('[loop-slider] mount failed', e);
    }
    return true;
  }

  function mountAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('.loop-slider:not(.is-initialized)');
    Array.prototype.forEach.call(nodes, function (el) {
      mount(el);
    });
  }

  // Splide が読めなかった時だけフォールバック表示（先頭スライド）を有効化
  function revealFallback() {
    var nodes = document.querySelectorAll('.loop-slider:not(.is-initialized)');
    Array.prototype.forEach.call(nodes, function (el) {
      el.classList.add('loop-slider--js-failed');
    });
  }

  // Splide の読み込み完了を待ってから初期化
  function whenReady(cb, tries) {
    tries = tries || 0;
    if (typeof Splide !== 'undefined') return cb();
    if (tries > 100) {
      // ~5秒待っても読めない（CDN障害/JSブロック等）→ フォールバック表示
      revealFallback();
      return;
    }
    setTimeout(function () {
      whenReady(cb, tries + 1);
    }, 50);
  }

  function init() {
    whenReady(function () {
      mountAll(document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // テーマエディタでの再描画に対応
  document.addEventListener('shopify:section:load', function (e) {
    whenReady(function () {
      mountAll(e.target || document);
    });
  });

  // テーマエディタでセクション削除/再描画時、旧インスタンスを破棄（タイマー・リスナのリーク防止）
  document.addEventListener('shopify:section:unload', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('.loop-slider') : null;
    if (el && el._splideInstance) {
      try {
        el._splideInstance.destroy();
      } catch (err) {
        /* noop */
      }
      el._splideInstance = null;
    }
  });
})();
